var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMembresia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.28 26.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49,26.04l-2.36-4.03-4.68-.96,.53-4.56L0,13.02l2.98-3.44-.53-4.56,4.68-.96L9.49,0l4.15,1.92,4.15-1.92,2.39,4.06,4.65,.96-.53,4.56,2.98,3.44-2.98,3.47,.53,4.56-4.65,.96-2.39,4.03-4.15-1.92-4.15,1.92Zm.84-2.45l3.32-1.4,3.41,1.4,2.08-3.1,3.63-.93-.37-3.69,2.51-2.85-2.51-2.91,.37-3.69-3.63-.87-2.14-3.1-3.35,1.4-3.41-1.4-2.08,3.1-3.63,.87,.37,3.69-2.51,2.91,2.51,2.85-.37,3.75,3.63,.87,2.17,3.1Zm1.98-6.45l7.04-6.98-1.4-1.27-5.64,5.58-2.95-3.07-1.43,1.4,4.37,4.34Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembresia);
export default __webpack_public_path__ + "static/media/membresia.f4df8040fd6097a9425762a4cc0a6606.svg";
export { ForwardRef as ReactComponent };